export enum EnumStatusSalao {
    ATIVO = 1,
    INATIVO = 2,
}